import { atom } from 'jotai';

export const amountAtom = atom<string>('');
export const purposeAtom = atom<string>('');
export const emailAtom = atom<string>('');
export const nameAtom = atom<string>('');